module.exports = __webpack_public_path__ + "static/img/2.bdbbb60.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/2.png
// module id = ecY1
// module chunks = 0